import { render, staticRenderFns } from "./DeleteConfirm.vue?vue&type=template&id=b8322c92&"
import script from "./DeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports